/* Intent matching for voice commands — synonyms in English, Hindi, Tamil + fuzzy matching for near misses. */

const INTENTS = [
  { id: "case:next", p: ["next case", "next one", "next", "go next", "अगला केस", "अगला", "agla case", "adutha case", "அடுத்த கேஸ்", "அடுத்தது", "adutha"] },
  { id: "case:prev", p: ["previous case", "previous", "last case", "go back", "पिछला केस", "पिछला", "pichla case", "munthaiya case", "முந்தைய கேஸ்", "முந்தையது"] },
  { id: "close", p: ["close", "close it", "close this", "dismiss", "exit", "बंद करो", "बंद", "band karo", "moodu", "மூடு", "close pannu"] },
  { id: "chat:open", p: ["open chat", "ask andrew", "talk to andrew", "start chat", "open the chat", "chat", "चैट खोलो", "एंड्रयू से पूछो", "chat kholo", "chat thira", "சாட் திற", "ஆண்ட்ரூவிடம் கேள்"] },
  { id: "chat:close", p: ["close chat", "close the chat", "end chat", "चैट बंद करो", "chat band karo", "chat moodu", "சாட் மூடு"] },
  { id: "voicemail", p: ["leave a voicemail", "voicemail", "voice mail", "record a message", "leave a message", "वॉइसमेल", "संदेश छोड़ो", "voicemail chhodo", "voicemail vidu", "குரல் செய்தி", "வாய்ஸ்மெயில்"] },
  { id: "link:linkedin", p: ["open linkedin", "linkedin", "connect on linkedin", "लिंक्डइन खोलो", "linkedin kholo", "linkedin thira", "லிங்க்டின் திற"] },
  { id: "link:github", p: ["open github", "github", "show code", "गिटहब खोलो", "github kholo", "github thira", "கிட்ஹப் திற"] },
  { id: "opening", p: ["opening statement", "opening statements", "play opening statement", "play the opening statement", "hear the opening", "शुरुआती बयान", "opening statement sunao", "opening statement kelu", "தொடக்க வாதம்"] },
  { id: "transcript", p: ["read the transcript", "transcript", "show transcript", "open transcript", "pre transcribe", "pretranscribe", "ट्रांसक्रिप्ट", "ट्रांसक्रिप्ट पढ़ो", "transcript padho", "transcript kaatu", "டிரான்ஸ்கிரிப்ட்"] },
  { id: "help", p: ["what can i say", "help", "show commands", "what can you do", "commands", "मैं क्या कह सकता हूँ", "मदद", "main kya keh sakta hoon", "enna solla mudiyum", "நான் என்ன சொல்லலாம்", "உதவி"] },
  { id: "top", p: ["back to top", "go to top", "top of page", "ऊपर जाओ", "सबसे ऊपर", "upar jao", "top ku po", "மேலே போ", "மேலே செல்"] },
  { id: "scroll:up", p: ["scroll up", "go up", "page up", "ऊपर स्क्रॉल", "upar scroll", "mela scroll", "மேலே ஸ்க்ரோல்"] },
  { id: "scroll:down", p: ["scroll down", "go down", "page down", "नीचे स्क्रॉल", "नीचे जाओ", "neeche scroll", "keezha scroll", "கீழே ஸ்க்ரோல்", "கீழே போ"] },
  { id: "stop", p: ["stop", "stop talking", "be quiet", "pause", "mute", "रुको", "चुप", "ruko", "nirutthu", "நிறுத்து", "அமைதி"] },
  { id: "play", p: ["play", "resume", "continue", "read it", "read aloud", "listen", "चलाओ", "पढ़ो", "सुनाओ", "chalao", "padho", "play pannu", "படி", "ஒலி"] },
  { id: "nav:home", p: ["home", "go home", "take me home", "home page", "start", "होम", "घर", "home jao", "home ku po", "முகப்பு", "ஹோம்"] },
  { id: "nav:about", p: ["about", "about you", "about andrew", "who are you", "tell me about yourself", "the attorney", "बारे में", "अपने बारे में", "about dikhao", "about kaatu", "உன்னைப் பற்றி", "பற்றி"] },
  { id: "nav:cases", p: ["show me your projects", "show projects", "show project", "projects", "cases", "case files", "show cases", "take me to the cases", "your work", "portfolio", "show me your work", "प्रोजेक्ट दिखाओ", "केस दिखाओ", "केस", "project dikhao", "case dikhao", "project kaatu", "case kaatu", "ப்ராஜெக்ட் காட்டு", "கேஸ் காட்டு", "கேஸ்கள்"] },
  { id: "nav:evidence", p: ["evidence", "show evidence", "things you owned", "what you owned", "ownership", "सबूत", "सबूत दिखाओ", "saboot dikhao", "evidence kaatu", "ஆதாரம்", "ஆதாரம் காட்டு"] },
  { id: "nav:tools", p: ["tools", "tech stack", "your stack", "tools of the trade", "skills", "stack", "टूल्स", "तकनीक", "tools dikhao", "stack kaatu", "கருவிகள்", "ஸ்டாக்"] },
  { id: "nav:languages", p: ["languages", "three languages", "say hello", "greetings", "भाषाएं", "भाषा", "bhasha", "mozhigal", "மொழிகள்", "மொழி"] },
  { id: "nav:credentials", p: ["credentials", "certifications", "certificates", "badges", "प्रमाण पत्र", "सर्टिफिकेट", "certificate dikhao", "certificate kaatu", "சான்றிதழ்", "சான்றிதழ்கள்"] },
  { id: "nav:terms", p: ["terms", "terms of engagement", "availability", "are you available", "notice period", "hiring", "शर्तें", "उपलब्धता", "terms dikhao", "availability kaatu", "நிபந்தனைகள்", "கிடைக்குமா"] },
  { id: "nav:contact", p: ["contact", "contact support", "go to contact", "get in touch", "reach you", "call andrew", "hire you", "संपर्क", "संपर्क करो", "contact karo", "contact pannu", "தொடர்பு", "தொடர்பு கொள்"] },
];

const NUMBER_WORDS = {
  1: ["1", "one", "first", "एक", "पहला", "ek", "pehla", "onnu", "ondru", "mudhal", "ஒன்று", "முதல்"],
  2: ["2", "two", "second", "दो", "दूसरा", "do", "doosra", "rendu", "irandu", "இரண்டு", "இரண்டாவது"],
  3: ["3", "three", "third", "तीन", "तीसरा", "teen", "teesra", "moonu", "moondru", "மூன்று", "மூன்றாவது"],
  4: ["4", "four", "fourth", "चार", "चौथा", "char", "chautha", "naalu", "nangu", "நான்கு", "நான்காவது"],
};
const CASE_WORDS = ["case", "केस", "कैस", "கேஸ்", "வழக்கு", "project", "प्रोजेक्ट"];
const STOP = new Set(["to", "the", "a", "an", "me", "please", "go", "take", "us", "my", "your", "can", "you", "i", "want", "now", "and", "then", "just", "hey", "andrew", "मुझे", "को", "पर", "एन்னை", "எனக்கு"]);
const strip = (tokens) => { const t = tokens.filter((x) => !STOP.has(x)); return t.length ? t : tokens; };

const normalize = (s) => s.toLowerCase().replace(/[^\p{L}\p{N}\s]/gu, " ").replace(/\s+/g, " ").trim();

const lev = (a, b) => {
  const m = a.length, n = b.length;
  if (!m) return n; if (!n) return m;
  let prev = Array.from({ length: n + 1 }, (_, j) => j);
  for (let i = 1; i <= m; i++) {
    const cur = [i];
    for (let j = 1; j <= n; j++) {
      cur[j] = Math.min(prev[j] + 1, cur[j - 1] + 1, prev[j - 1] + (a[i - 1] === b[j - 1] ? 0 : 1));
    }
    prev = cur;
  }
  return prev[n];
};
const sim = (a, b) => 1 - lev(a, b) / Math.max(a.length, b.length, 1);

const phraseScore = (rawTokens, phrase) => {
  const joined = rawTokens.join(" ");
  if (joined === phrase) return 1;
  if (` ${joined} `.includes(` ${phrase} `)) return 0.97 + Math.min(0.02, phrase.split(" ").length * 0.005);
  const tokens = strip(rawTokens);
  const pt = strip(phrase.split(" "));
  // fuzzy: every phrase token should have a close transcript token
  let total = 0, weakest = 1;
  for (const p of pt) {
    let best = 0;
    for (const t of tokens) best = Math.max(best, sim(t, p));
    total += best;
    weakest = Math.min(weakest, best);
  }
  if (weakest < 0.6) return 0;
  const avg = total / pt.length;
  // extra unmatched content words in the transcript lower confidence
  const coverage = Math.min(1, pt.length / tokens.length);
  return avg * (0.9 + 0.06 * coverage);
};

const extractCaseNumber = (tokens) => {
  for (const t of tokens) {
    for (const [n, words] of Object.entries(NUMBER_WORDS)) if (words.includes(t)) return Number(n);
    if (/^\d+$/.test(t)) { const d = t.split("").find((c) => "1234".includes(c)); if (d) return Number(d); }
  }
  return null;
};

/** Returns { intent, arg, score } or null */
export const matchCommand = (transcript) => {
  const text = normalize(transcript);
  if (!text) return null;
  const tokens = text.split(" ");

  const hasCaseWord = tokens.some((t) => CASE_WORDS.some((c) => sim(t, c) > 0.75));
  const num = extractCaseNumber(tokens);
  if (hasCaseWord && num) return { intent: "case:open", arg: num, score: 1 };

  let best = { intent: null, score: 0 };
  for (const it of INTENTS) {
    for (const phrase of it.p) {
      const s = phraseScore(tokens, normalize(phrase));
      if (s > best.score) best = { intent: it.id, score: s };
    }
  }
  return best.score >= 0.74 ? best : null;
};

export const HELP_COMMANDS = [
  "show cases", "open case 2", "next case", "previous case", "close",
  "about", "evidence", "tools", "languages", "credentials", "terms", "contact",
  "opening statement", "read the transcript", "play", "stop",
  "open chat", "close chat", "leave a voicemail", "open LinkedIn", "open GitHub",
  "scroll up", "scroll down", "back to top",
];
